import { createIcon } from './icon-utils';

export const CloseIcon = createIcon({
  path: 'M4.94 6L.781 1.842C.49 1.55.49 1.075.782.782c.293-.293.768-.293 1.06 0L6 4.939 10.157.782c.293-.293.768-.293 1.06 0 .294.293.294.768 0 1.06L7.062 6l4.157 4.157c.293.293.293.768 0 1.06-.293.293-.768.293-1.06 0L6 7.06l-4.157 4.157c-.293.293-.768.293-1.06 0-.294-.292-.294-.767 0-1.06L4.938 6z',
  viewBox: '0 0 12 12',
});
